import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-text-area-freeform',
    templateUrl: './text-area-freeform.component.html',
    styleUrls: ['./text-area-freeform.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextAreaFreeformComponent {
  @Input() rows: number = 5;
  @Input() value: string = '';
  @Input() required: boolean = false;
  @Input() isReadonly: boolean = false;
  @Input() caption: string;
  @Input() errorMessage: string;
  @Input() helpText: string;
  @Output() textChange = new EventEmitter<string>();

  onTextChange(e: Event) {
    this.textChange.emit((e.target as HTMLTextAreaElement).value);
  }
}
